module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "outer",
    staticClass: "vue-virtual-collection",
    style: (_vm.outerStyle),
    on: {
      "&scroll": function($event) {
        return _vm.onScroll($event)
      }
    }
  }, [_vm._t("header"), _vm._v(" "), _c('div', {
    staticClass: "vue-virtual-collection-container",
    style: (_vm.containerStyle)
  }, _vm._l((_vm.displayItems), function(item) {
    return _c('div', {
      key: item.key,
      staticClass: "cell-container",
      style: (_vm.getComputedStyle(item))
    }, [_vm._t("cell", null, {
      "data": item.data
    })], 2)
  }), 0)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-75486378"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/VirtualCollection.vue
// module id = 9
// module chunks = 0